import React from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import sanitize from 'sanitize-html';
import cx from 'classnames';
import { addTooltipToStyledContent } from 'components/StyledContent/addTooltipToStyledContent';
import styles from './styles.module.scss';

const StyledContentLinks = ({ linksList }) => {
	const renderItems = (orderedItems) =>
		orderedItems.map((item, index) => (
			<span
				key={item.text.substring(0, 30 + index)}
				className={styles.StyledContentLinks_Link}
			>
				<>
					{parse(sanitize(item.text), { replace: addTooltipToStyledContent })}
				</>
			</span>
		));

	return (
		<div
			className={cx(
				styles.StyledContentLinks,
				styles[`StyledContentLinks__float${linksList.align}`]
			)}
		>
			<div className={styles.StyledContentLinks_Title}>{linksList.title}</div>
			<div className={styles.StyledContentLinks_List}>
				{renderItems(linksList.items)}
			</div>
		</div>
	);
};

StyledContentLinks.propTypes = {
	linksList: PropTypes.shape({
		title: PropTypes.string.isRequired,
		align: PropTypes.oneOf(['left', 'right']).isRequired,
		items: PropTypes.arrayOf(
			PropTypes.shape({
				text: PropTypes.string,
				type: PropTypes.oneOf(['listItem']).isRequired
			})
		).isRequired
	})
};

export default StyledContentLinks;
